/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { ViewClientModel } from "../../common/model/viewclient-model";
import { UtilService } from "./util-service";
import { Localize } from "../../common/service/localize.service";
import { Component, ElementRef, ChangeDetectorRef, AfterViewInit } from "@angular/core";
import { TranslateService } from "@html-core";

@Component({
   standalone: false,
   selector: "help-link",
   template:
      '<a class="home-link" open-chrome-link id="helpLink" href="" target="_blank" [hidden]="!showHelpLink" rel="{{linkRelValue}}"></a>'
})
export class HelpLinkComponent implements AfterViewInit {
   public showHelpLink: boolean;
   public linkRelValue: string;
   private helpUrl: string;
   private element: JQuery;
   constructor(
      private viewClientModel: ViewClientModel,
      private utilService: UtilService,
      private translate: TranslateService,
      private localize: Localize,
      private _el: ElementRef,
      private changeDetector: ChangeDetectorRef
   ) {}
   ngAfterViewInit() {
      this.element = $(this._el.nativeElement.children[0]);
      this.localize.localeReady$.subscribe((ready) => {
         setTimeout(() => {
            if (ready) {
               this.showLink();
            }
         });
      });

      this.linkRelValue = __REL_FOR_LINK__;
      this.changeDetector.detectChanges();
   }

   private showLink = () => {
      //Rebrand the help URL
      this.helpUrl = this.viewClientModel.rebrandHelpUrl || this.utilService.getLinkByType("helpPages");
      const name = this.translate._T("help_with_omnissa_horizon");
      this.element.html(name);
      this.element.attr("href", this.helpUrl);
      this.showHelpLink = true;
   };
}
